import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    let patient = data?.vaxiom_patients?.[0]
    let booking = data?.vaxiom_appointment_bookings?.[0]

    if (!patient && !booking) return null

    if (booking?.id) {
      return {
        ...booking.appointment.patient,
        booking: { ...booking },
      }
    }

    return patient
  }, [data])
}
